// extracted by mini-css-extract-plugin
export var $animation_name = "CompetitionForm-module--$animation_name--e9639";
export var check = "CompetitionForm-module--check--3b2c7";
export var entrySubmit = "CompetitionForm-module--entrySubmit--be35b";
export var formWrapper = "CompetitionForm-module--formWrapper--6b195";
export var full = "CompetitionForm-module--full--bf7f8";
export var fullWidth = "CompetitionForm-module--fullWidth--4e957";
export var half = "CompetitionForm-module--half--a2184";
export var introText = "CompetitionForm-module--introText--275e5";
export var sendError = "CompetitionForm-module--sendError--8003d";
export var wrapper = "CompetitionForm-module--wrapper--c3947";